import { ProductsServicesSection } from "@edp-pages/edpe/energy-efficiency/components/products-services-sections/product-services-section.model";
import { Card } from "./benefits.model";

export interface EfficiencyTotal {
    seedsAcquisition: number;
    seedsProfile: number;
    totalSegmentInterval: number;
    seedsSustainableConsumption: number;
    efficiency: string;
    averageInterval: number;
}

export interface IContractEfficiency {
    contractId: string;
    lastPeriod: string;
    lastPeriodSegmentInterval: number;
    lastPeriodAcquisition: number;
    lastPeriodSustainableConsumption: number;
    totalSegmentInterval: number;
    totalSeedsAcquisition: number;
    totalSeedsSustainableConsumption: number;
    seedsProfile: number;
    totalEfficiency: EfficiencyLevel;
    totalAverageInterval: number;
    lastPeriodEfficiency: EfficiencyLevel;
    lastPeriodAverageInterval: number;
    percentageCO2Segment: number;
}

export interface Efficiency {
    name: string;
    subscribed: number;
    seeds: number;
    total?: number;
    averageInterval?: string;
    efficiency?: string;
    title?: string;
    link?: string;
    routerLink?: string[];
}

export interface IUserEfficiency {
    total: EfficiencyTotal;
    contracts: IContractEfficiency[];
    efficiency: Efficiency[];
    startAnnualPeriod: string;
    endAnnualPeriod: string;
    profileSeedsValue: number;
}

export interface ProductServiceCard {
    title: string;
    linkUrl: string;
    image: string;
    imageUrl?: string;
    description?: string;
    type?: ProductServiceType;
    code?: ProductServiceCode;
    action?: string;
    conditionalLinkUrl?: string;
    conditionalLinkLabel?: string;
    linkUrlParams?: object;
    section?: ProductsServicesSection;
    hasPoints?: boolean;
    serviceData?: ProductServiceData;
}

export class ProductServiceCardsFactory {
    static generateInitialCards(): ProductServiceCard[] {
        return [{
                title: "pt.edp.edponline.services.wallbox",
                linkUrl: "pt.edp.edponline.services.wallboxLink",
                description: "pt.edp.edponline.services.wallboxDescription",
                image: "pt.edp.edponline.services.wallboxImage",
                section: ProductsServicesSection.ElectricMobility,
                code: ProductServiceCode.WALLB,
            },
            {
                title: "pt.edp.edponline.services.CEME",
                linkUrl: "pt.edp.edponline.services.CEMELink",
                description: "pt.edp.edponline.services.CEMEDescription",
                image: "pt.edp.edponline.services.CEMEImage",
                type: ProductServiceType.MOBIE,
                section: ProductsServicesSection.ElectricMobility,
                code: ProductServiceCode.MOBIE,
            },
            {
                title: "pt.edp.edponline.services.solarEnergy",
                linkUrl: "pt.edp.edponline.services.solarEnergyLink",
                description: "pt.edp.edponline.services.solarDescription",
                image: "pt.edp.edponline.services.soalrEnergyImage",
                section: ProductsServicesSection.RenewableEnergy,
                code: ProductServiceCode.SOLAR,
            },
            {
                title: "pt.edp.edponline.services.greenEnergy",
                linkUrl: "pt.edp.edponline.services.greenEnergyLink",
                description: "pt.edp.edponline.services.greenEnergyDescription",
                image: "pt.edp.edponline.services.greenEnergyImage",
                type: ProductServiceType.GREEN_ENERGY,
                section: ProductsServicesSection.RenewableEnergy,
                code: ProductServiceCode.GENERGY,
            },
            {
                title: "pt.edp.edponline.services.packsLiving",
                linkUrl: "pt.edp.edponline.services.packsLivingLink",
                description: "pt.edp.edponline.services.packsLivingDescription",
                image: "pt.edp.edponline.services.packsLivingImage",
                type: ProductServiceType.PACKS,
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.PACKEASY
            },
            {
                title: "pt.edp.edponline.services.packsLiving",
                linkUrl: "pt.edp.edponline.services.packsLivingLink",
                description: "pt.edp.edponline.services.packsLivingDescription",
                image: "pt.edp.edponline.services.packsLivingImage",
                type: ProductServiceType.PACKS,
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.PACKSMRT
            },
            {
                title: "pt.edp.edponline.services.packsLiving",
                linkUrl: "pt.edp.edponline.services.packsLivingLink",
                description: "pt.edp.edponline.services.packsLivingDescription",
                image: "pt.edp.edponline.services.packsLivingImage",
                type: ProductServiceType.PACKS,
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.PACKFULL
            },
            {
                title: "pt.edp.edponline.services.electricHouse",
                linkUrl: "pt.edp.edponline.services.electricHouseLink",
                description: "pt.edp.edponline.services.electricHouseDescription",
                image: "pt.edp.edponline.services.electricHouseImage",
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.CASAELETRICA,
            },
            {
                title: "pt.edp.edponline.services.electronicInvoice",
                linkUrl: "",
                description: "pt.edp.edponline.services.electronicInvoiceDescription",
                image: "pt.edp.edponline.services.electronicInvoiceImage",
                type: ProductServiceType.ELECTRONIC_INVOICE,
                conditionalLinkLabel: "pt.edp.edponline.energyConsumption.subscribe",
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.EINVOICE,
            },
            {
                title: "pt.edp.edponline.services.contractInformation",
                linkUrl: "pt.edp.edponline.services.contractInformationLink",
                description: "pt.edp.edponline.services.contractInformationDescription",
                image: "pt.edp.edponline.services.contractInformationImage",
                action: "moreInfo",
                type: ProductServiceType.CONTRACT,
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.NONE,
            },
            {
                title: "pt.edp.edponline.services.redy",
                linkUrl: "pt.edp.edponline.services.redyLink",
                description: "pt.edp.edponline.services.redyDescription",
                image: "pt.edp.edponline.services.redyImage",
                type: ProductServiceType.REDY,
                conditionalLinkUrl: "pt.edp.edponline.energyConsumption.redyWeb",
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.REDY,
            },
            {
                title: "pt.edp.edponline.services.lightsCheckup",
                linkUrl: "pt.edp.edponline.services.lightsCheckupLink",
                description: "pt.edp.edponline.services.lightsCheckupDescription",
                image: "pt.edp.edponline.services.lightsCheckupImage",
                type: ProductServiceType.SERVICE,
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.FUNCHKILM,
            },
            {
                title: "pt.edp.edponline.services.equipamentCheckup",
                linkUrl: "pt.edp.edponline.services.equipamentCheckupLink",
                description: "pt.edp.edponline.services.equipamentCheckupDescription",
                image: "pt.edp.edponline.services.equipamentCheckupImage",
                type: ProductServiceType.SERVICE,
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.FUNCHKEQP,
            },
            {
                title: "pt.edp.edponline.services.technicalAssistance",
                linkUrl: "pt.edp.edponline.services.technicalAssistanceLink",
                description: "pt.edp.edponline.services.technicalAssistanceDescription",
                image: "pt.edp.edponline.services.technicalAssistanceImage",
                type: ProductServiceType.SERVICE,
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.FUNASSTEC,
            },
            {
                title: "pt.edp.edponline.services.electricalOverhaul",
                linkUrl: "pt.edp.edponline.services.electricalOverhaulLink",
                description: "pt.edp.edponline.services.electricalOverhaulDescription",
                image: "pt.edp.edponline.services.electricalOverhaulImage",
                type: ProductServiceType.SERVICE,
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.FUNREVELC,
            },
            {
                title: "pt.edp.edponline.services.energeticCertification",
                linkUrl: "pt.edp.edponline.services.energeticCertificationLink",
                description: "pt.edp.edponline.services.energeticCertificationDescription",
                image: "pt.edp.edponline.services.energeticCertificationImage",
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.CERTEN,
            },
            {
                title: "pt.edp.edponline.services.energyAudit",
                linkUrl: "pt.edp.edponline.services.energyAuditLink",
                description: "pt.edp.edponline.services.energyAuditDescription",
                image: "pt.edp.edponline.services.energyAuditCardImage",
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.AUDITE,
            },
            {
                title: "pt.edp.edponline.services.electricMobilityCard",
                linkUrl: "pt.edp.edponline.services.electricMobilityCardLink",
                description: "pt.edp.edponline.services.electricMobilityCardDescription",
                image: "pt.edp.edponline.services.electricMobilityCardImage",
                type: ProductServiceType.MOBIE,
                section: ProductsServicesSection.EfficientHouse,
                code: ProductServiceCode.NONE,
            }
        ];
    }
}

export enum ProductServiceCode {
    NONE,
    SOLAR,
    VSUN,
    GENERGY,
    WALLB,
    MOBIE,
    CASAELETRICA,
    EINVOICE,
    REDY,
    FUNCHKILM,
    FUNCHKEQP,
    FUNASSTEC,
    FUNREVELC,
    CERTEN,
    AUDITE,
    PACKEASY,
    PACKSMRT,
    PACKFULL
}

export enum ProductServiceType {
    CONTRACT,
    ELECTRONIC_INVOICE,
    REDY,
    PACKS,
    SERVICE,
    GREEN_ENERGY,
    OPPORTUNITY,
    MOBIE,
    VSUN
}

export interface ContractPsData {
    contractId: string;
    cards: ProductServiceCard[];
}

export interface ContractPsServiceData {
    contractId: string;
    cardData: ProductServiceData[];
}

export interface ProductServiceData {
    code?: string;
    initialZsOS: string;
    initialZsCT: string;
    ZsOS: string;
    ZsCT: string;
    energy?: Energy;
    used: boolean;
}

export interface Energy {
    lastMonth: string;
    co2: string;
}

export enum EfficiencyLevel {
    HIGH = "HIGH",
    MEDIUM = "MEDIUM",
    LOW = "LOW",
    VERYHIGH = "VERYHIGH",
}

export interface UserEfficiencyData {
    id: string;
    title: string;
    levels: Level[];
    profiles: Profile[];
    cards: Card[];
}

export interface Level {
    id: number;
    label: string;
}

export interface Profile {
    id: number;
    image: string;
    label: string;
}

export interface ComparatorEfficientHouseDataStation {
    winter?: number;
    summer?: number;
    autumn?: number;
    spring?: number;
}

export interface ComparatorEfficientHouseData {
    last_month: number;
    last_station_of_last_year: ComparatorEfficientHouseDataStation;
    percentage: number;
}

export interface ComparatorEfficientHouse {
    energy_efficiency: ComparatorEfficientHouseData;
}

export interface ComparatorElectricMobility {
    consumptionKwh: number;
    c02Consumption: number;
    evarageKmTraveled: number;
    isCEME: boolean;
}


export class ContractEfficiency implements IContractEfficiency {

    contractId: string;
    lastPeriod: string;
    lastPeriodSegmentInterval: number;
    lastPeriodAcquisition: number;
    lastPeriodSustainableConsumption: number;
    totalSegmentInterval: number;
    totalSeedsAcquisition: number;
    totalSeedsSustainableConsumption: number;
    seedsProfile: number;
    totalEfficiency: EfficiencyLevel;
    totalAverageInterval: number;
    lastPeriodEfficiency: EfficiencyLevel;
    lastPeriodAverageInterval: number;
    lastPeriodDate: Date;
    hasFilledProfile: boolean;
    percentageCO2Segment: number;

    constructor(private _iContractEfficiency: IContractEfficiency) {
        Object.assign(this, _iContractEfficiency);
        this.lastPeriodDate = this.lastPeriod && new Date(this.lastPeriod);
        this.hasFilledProfile = this.seedsProfile > 0;
        delete this._iContractEfficiency;
    }
}

